import React, { forwardRef } from 'react';
import { Box } from '@mui/material';
import ReactQuill from 'react-quill';
import '../quill-editor-fix.css';
import { FieldLabel, editorBoxSx } from './FormSection';

const CourseGuide = forwardRef(({ value, onChange, error }, ref) => (
  <Box ref={ref}>
    <FieldLabel hint="Mínimo 80 caracteres - Máximo 400" error={error}>
      Guía del curso
    </FieldLabel>
    <Box sx={editorBoxSx({ xs: 200, md: 240 }, error)}>
      <ReactQuill
        value={value || ''}
        onChange={onChange}
        theme="snow"
        placeholder="Objetivos, metodología y recomendaciones para el participante..."
        style={{ flex: 1, minHeight: 0, height: '100%' }}
      />
    </Box>
  </Box>
));

export default CourseGuide;
